<template>
  <div class="motivos">
    <div v-if="!recibido" v-loading="cargadorInterno">
    <h3 class="titulo-motivo">Ayuda con mi compra</h3>
    
    <PedidoDemorado
      :datos="datos"
      :enTiempo="enTiempo"
      v-if="datos.sc_ultimo_estado < 30"
    />
    <div v-if="menuMotivos == 'entregado'">
      <div v-for="m in menuEntregado" :key="m.id">
        <el-button
          class="btnMotivos"
          size="medium"
          @click="procesarMotivoEntregado(m.id)"
          plain
          v-if="m.id == 'reintegro' && datos.fecha_dev"
         
        >
           {{ m.label }}
            <i v-if="m.label != 'Regresar'" class="el-icon-arrow-right"></i>
            <i v-else class="el-icon-arrow-left"></i>
        </el-button>

        <el-button
          class="btnMotivos"
          size="medium"
          @click="procesarMotivoEntregado(m.id)"
          plain
          :loading="cargando == m.id"
          v-if="m.id != 'reintegro'"
        
        >
          {{ m.label }}
           <i v-if="m.label != 'Regresar'" class="el-icon-arrow-right"></i>
           <i v-else class="el-icon-arrow-left"></i>
        </el-button>
      </div>
       <el-button
          class="btnMotivos"
          size="medium"
          v-if="$isMobile()"
          @click="regresarMobile"
          plain
          
         
        >
          Regresar
          <i class="el-icon-arrow-left"></i>
        </el-button>
    </div>
    <div v-if="!menuMotivos">
      <div
        v-if="cargando"
        v-loading="cargando"
        style="margin-top: 10px; height: 200px; border-radius: 16px"
        element-loading-text="actualizando información..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(255, 255, 255, 1)"
      ></div>

      <div>
        <div>
          <template>
            <div v-if="!mostrarOtros">
              <div v-for="m in motivos" :key="m.id">
                <el-button
                  class="btnMotivos"
                  size="medium"
                  @click="procesarMotivo(m.id)"
                  plain
                >
              {{ m.motivo }}
                   <i v-if="m.motivo.toLowerCase().trim() != 'regresar'" class="el-icon-arrow-right"></i>
                   <i v-else class="el-icon-arrow-left"></i>
                  
                </el-button>
              </div>
             
            </div>
            <div v-if="mostrarOtros">
              <div v-for="m in otrosMotivos" :key="m.id">
                <el-button
                  class="btnMotivos"
                  size="medium"
                  @click="procesarOtrosMotivo(m.id)"
                  plain
                >
                  {{ m.label }} 
                   <i v-if="m.label != 'Regresar'" class="el-icon-arrow-right"></i>
                     <i v-else class="el-icon-arrow-left"></i>
                </el-button>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    </div>
      <FormArrepentimiento :datos="datos" />
      <modalNoProcesado />
      <modalDemorado />
      <modalConfirmaRecibido :datos="datos"  />
      <modalFaltantes />
      <modalNoretira :datos="datos"/>

      <transition name="fade">
        <ListadoProductos
          :detallePedido="detallePedido"
          :datos="datos"
          :motivo="motivo"
        />
      </transition>
    
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "@/event-bus.js";
export default {
  props: ["datos"],
  components: {
    ListadoProductos: () => import("@/components/listadoProductos"),
    PedidoDemorado: () => import("@/components/pedidoDemorado"),
    FormArrepentimiento: () => import("@/components/FormArrepentimiento"),
    modalDemorado: () => import("@/components/modalDemorado"),
    modalFaltantes: () => import("@/components/modalFaltantes"),
    modalConfirmaRecibido: () => import("@/components/modalConfirmaRecibido"),
    modalNoretira: () => import("@/components/modalNoretira"),
    modalNoProcesado: () => import("@/components/modalNoProcesado"),
  },
  data() {
    return {
      cargadorInterno: false,
      recibido: false,
      enTiempo: false,
      hoy: this.$date(new Date()).format("YYYY-MM-DD"),
      cargando: true,
      motivo: 0,
      dias_entrega: 10,
      conReclamo: false,
      detallePedido: false,
      menuMotivos: false,
      motivosAux: false,
      motivosArray: [],
      motivos: [],
      existe: null,
      mostrarOtros: false,

      menuEntregado: [
        { id: "pedido", label: "Consultas sobre mi pedido" },
        { id: "reintegro", label: "Consultas sobre reintegros" },
        { id: "noesta", label: "La farmacia no tiene mi pedido" },
        {
          id: "marcado",
          label: "Recibí la notificación de PEDIDO ENTREGADO pero yo no lo retiré",
        },
         
      ],
      otrosMotivos: [
        { id: "pf", label: "Preguntas frecuentes" },
        { id: "ac", label: "Arrepentimiento de compra" },
        { id: "tyc", label: "Terminos y condiciones" },
        {
          id: "oc",
          label: "Quiero realizar una consulta relacionada a esta compra",
        },
        { id: "r", label: "Regresar" },
      ],
    };
  },
  created() {
    this.enTiempo = this.datos.fecha_estimada
      ? this.$date(this.datos.fecha_estimada.date).isAfter(new Date())
      : false;
    this.fechaEntrega = this.datos.fecha_estimada
      ? this.$date(this.datos.fecha_estimada.date).isAfter(new Date())
      : false;
    EventBus.$on("cambiarEstado", (e) => {
      this.recibido = false
      this.datos.sc_ultimo_estado = e;
      this.datos.fecha_ultimo_estado.date = new Date();
      this.datos.seguimiento.push({
        estado: e,
        fecha: new Date(),
      
      });
      this.setMenuMotivos(e);
      this.getMotivos(e);

      EventBus.$emit("ModalConfirmarRecepcion", false);
      this.recibido = false;
    });

    EventBus.$on("motivo10", (val) => {
      this.motivosAux = val;
    });

    EventBus.$on("cerrarDemorado", () => {
      this.motivo = 0;
      this.conReclamo = false;
      this.recibido = false;
    });
    EventBus.$on("cerrarModal", () => {
      this.detallePedido = undefined;
      this.motivo = 0;
      this.conReclamo = false;
    });

    EventBus.$on("datosPedido", (datos) => {
      console.log("DATOS DEL PEDIDO", datos);
    });

    EventBus.$on("loading-motivos", (val) => {
      this.cargando = val;
    });

    // if (!this.mostrarChat) {
    // console.log('verificar caso');

    // }
  },
  watch: {
    // mostrarChat() {
    //   this.verificaCaso();
    // },
  },
  mounted() {
    setTimeout(() => {
      this.cargando = false;
      this.setMenuMotivos(this.datos.sc_ultimo_estado);
      this.getMotivos(this.datos.sc_ultimo_estado);
      console.log("DATOS DEL PEDIDO", this.datos);
      console.log("EN TIEMPO?", this.enTiempo);
    }, 2500);
  },

  computed: {
    ...mapGetters([
      // "datos",
      "dataVtex",
      "iniciarReclamo",
      "pedidoCancelado",
      "messages",
      "numeroCaso",
      "mostrarChat",
      // "fechaEntrega",
      // "enTiempo",
      // "dias30",
    ]),

    pedidoEnFarmacias() {
      return this.enFarmaciaHasta
        ? this.enFarmaciaHasta.split("/")[2] +
            "-" +
            this.enFarmaciaHasta.split("/")[1] +
            "-" +
            this.enFarmaciaHasta.split("/")[0]
        : "";
    },
  },

  methods: {
    ...mapActions({
      vuexIsloading: "isLoading",
      vuexReclamo: "iniciarCasoAutWcx",
      vuexCancelarPedido: "cancelarPedido",
      vuexIniciarReclamoLocal: "iniciarReclamoLocal",
      vuexGuardarMensaje: "guardarMensaje",
      vuexCargando: "isLoading",
      vuexCrearCasoWebCentrix: "crearCasoWebCentrix",
      vuexprocesarReclamo: "procesarReclamo",
      vuexVerificarCasoLocalWC: "verificarCasoLocalWC",
    }),
    getMotivos(sc_ultimo_estado) {
      if (this.datos.sc_ultimo_estado && sc_ultimo_estado) {
        switch (sc_ultimo_estado) {
          case 10:
          case 20:
            if (!this.enTiempo) {
              this.motivosArray = [1, 3, 17];
            } else {
              this.motivosArray = [];
            }

            break;
          case 30:
            if(this.$isMobile())
            {
              this.motivosArray = [13, 14, 15, 16,18];
            }
            else
            {
             this.motivosArray = [13, 14, 15, 16];
            }
            
            break;
          case 31:
            this.motivosArray = [1, 3, 7, 16,];
            break;
          case 32:
            this.motivosArray = [1, 3, 7, 14, 16];
            break;
          case 40:
          case 41:
          case 50:
     
this.motivosArray = [2, 9, 6, 1];
            
            
            break;
        }

        this.motivos = this.datos.motivos.filter((e) => this.motivosArray.includes(e.id));

        console.log("this.sc_ultimo_estado", sc_ultimo_estado);
        console.log("this.enTiempo", this.enTiempo);
        console.log("this.motivos", this.motivos);
        console.log("this.motivosArray", this.motivosArray);
      }

      // return motivos
    },
    setMenuMotivos(sc_ultimo_estado) {
      switch (sc_ultimo_estado) {
        case 40:
        case 50:
          this.menuMotivos = "entregado";
          break;
        
        default:
          this.menuMotivos = false;
          break;
      }

      console.log("setMenuMotivos", sc_ultimo_estado);
      console.log("this.menuMotivos", this.menuMotivos);
      console.log("motivosArray", this.motivosArray);
    },

    async verificaCaso() {
      if (this.mostrarChat === false) {
        let existe = await this.vuexVerificarCasoLocalWC({
          vtex_id: this.datos.vtex_id,
        });
        if (!existe) {
          this.procesarMotivo(15);
        }
      }
    },
    verForm() {
      EventBus.$emit("openForm", true);
    },
    procesarMotivoEntregado(motivo) {
      switch (motivo) {
        case "pedido":
          this.menuMotivos = false;
          break;
        case "reintegro":
          this.motivos = this.datos.motivos.filter((e) => [10, 19,18].includes(e.id));
          this.menuMotivos = false;
          break;
        case "noesta":
          this.cargando = "noesta";
          this.procesarMotivo(8);
          break;
        case "marcado":
          this.motivos = this.datos.motivos.filter((e) => [14, 21,18].includes(e.id));
          this.menuMotivos = false;

          break;
      }
    },
    regresarMobile()
    {
      EventBus.$emit('regresarAlPedido', true);
    },
    procesarOtrosMotivo(motivo) {
      let motivoIngresado = this.datos.motivos.filter((e) => e.id == 1)[0];
      console.log("motivoIngresado", motivoIngresado);

      let datosWc = {
        dni: this.datos.dni,
        email: this.datos.mail_d ? this.datos.mail_d : "",
        fechaVtex: this.$date(this.datos.vtex_fecha.date).format("DD/MM/YYYY HH:mm"),
        nombre: this.datos.nombre + " " + this.datos.apellido,
       telefono: this.datos.telefono,
        totalOperacion: this.datos.importe / 100,
        wcTipo: motivoIngresado.wc_tipo ? motivoIngresado.wc_tipo : 0,
        vtex_id: this.datos.vtex_id,
        motivo_id: motivoIngresado.id ? motivoIngresado.id : 0,
      };

      this.datos.motivo_id = 1;

      switch (motivo) {
        case "oc":
          // datosWc.content = motivoIngresado.motivo;
          // datosWc.status = "open";
          EventBus.$emit("abriChat", true);
          // this.vuexCrearCasoWebCentrix({ datosWc, motivoIngresado });
          break;
        case "pf":
          window.open("https://www.farmaonline.com/preguntas-frecuentes", "_blank");
          break;
        case "tyc":
          window.open("https://www.farmaonline.com/terminos-y-condiciones", "_blank");
          break;
        case "ac":
          window.open("https://www.farmaonline.com/contacto", "_blank");
          break;
        case "r":
          this.mostrarOtros = false;
          break;
        default:
          this.mostrarOtros = false;
          break;
      }
    },
    procesarMotivo(motivo) {
      let motivoIngresado = this.datos.motivos.filter((e) => e.id == motivo)[0];
      this.datos.motivo = motivoIngresado.motivo;
      console.log("motivoIngresado", motivoIngresado);
      console.log("motivoIngresado motivo", motivo);

      let datosWc = {
        dni: this.datos.dni,
        email: this.datos.mail_d ? this.datos.mail_d : "",
        fechaVtex: this.$date(this.datos.vtex_fecha.date).format("DD/MM/YYYY HH:mm"),
        nombre: this.datos.nombre + " " + this.datos.apellido,
       telefono: this.datos.telefono,
        envio: this.datos.envio,
        totalOperacion: this.datos.importe / 100,
        wcTipo: motivoIngresado.wc_tipo ? motivoIngresado.wc_tipo : 0,
        vtex_id: this.datos.vtex_id,
        motivo_id: motivoIngresado.id ? motivoIngresado.id : 0,
      };

      this.datos.motivo_id = motivo;
      if (motivo == 17) {
        EventBus.$emit("openForm", true);
        return;
      }
      if (motivo == 18) {
        EventBus.$emit('regresarAlPedido', true);
        this.setMenuMotivos(this.datos.sc_ultimo_estado);
        return;
      }
      switch (motivo) {
        case 1:
          this.mostrarOtros = true;
          break;
        case 2:
        case 6:
        case 9:
          if (this.dataVtex.remove && this.dataVtex.remove.length) {
            console.log(
              "dataVetx form motibo",
              this.dataVtex.items.filter((i) => i.modificado)
            );
            EventBus.$emit(
              "verFaltantes",
              this.dataVtex.items.filter((i) => i.modificado)
            );
          } else {
            EventBus.$emit("verListadoProductos", true);
          }
          break;
        case 7:
          this.cargadorInterno = true;
          datosWc.content = motivoIngresado.motivo;
          datosWc.status = "open";
           this.vuexprocesarReclamo({ datosWc, motivoIngresado })
           .then((res) => {
             console.log("procesarArrepentimiento 7 res", res);
             EventBus.$emit("procesarArrepentimiento", res)
             this.cargadorInterno = false;
             });
         
          break;
        case 10:
        case 19:
          this.cargadorInterno = true;
          datosWc.content = motivoIngresado.motivo;
          datosWc.priority = "high";
          datosWc.status = "open";
          this.vuexprocesarReclamo({ datosWc, motivoIngresado })
           .then((res) => {
             console.log("procesarArrepentimiento 7 res", res);
             EventBus.$emit("procesarArrepentimiento", res)
             this.cargadorInterno = false;
             });
          break;
        case 101:
          this.datos.motivo_id = 10;
           this.cargadorInterno = true;
          datosWc.content = motivoIngresado.motivo;
          datosWc.status = "open";
          this.vuexprocesarReclamo({ datosWc, motivoIngresado })
           .then((res) => {
             console.log("procesarArrepentimiento 7 res", res);
             EventBus.$emit("procesarArrepentimiento", res)
             this.cargadorInterno = false;
             });
          break;
        case 15:
          this.procesarMotivo(8);
          break;
        case 13:
          EventBus.$emit("ModalConfirmarRecepcion", motivoIngresado);
          this.recibido = true;
          break;
        case 14:
          EventBus.$emit("verNoretira", true);

          break;

        case 21:
          datosWc.content = `Hola Recibí la notificación de PEDIDO ENTREGADO pero yo no lo retiré, en este reclamo confirmo que:  ${motivoIngresado.motivo.toLowerCase()}`;
          this.cargadorInterno = true;
          if (!this.dias30) {
            let result = this.vuexprocesarReclamo({ datosWc, motivoIngresado });
            result.then((res) => {
              
             EventBus.$emit("procesarArrepentimiento", res);
            });
          } else {
            datosWc.priority = "high";
            datosWc.wcTipo = 15493;
            datosWc.tags = ["Seguimiento"];

            datosWc.status = "open";
            this.cargando = false;
            let result = this.vuexprocesarReclamo({ datosWc, motivoIngresado });
            result.then((res) => {
             
             EventBus.$emit("procesarArrepentimiento", res);
            });
          }

          break;
      }

      if (motivo != 101) this.motivo = motivo;

      if (motivo == 10 && this.datos.importe_dev) {
        this.cargadorInterno = true;
        this.motivosAux = true;
        EventBus.$emit("verificarPago", "pago");
      } else if (motivo == 10 && !this.datos.importe_dev) {
        this.cargadorInterno = true;
        datosWc.content = motivoIngresado.motivo;
        datosWc.status = "open";
        let result = this.vuexprocesarReclamo({ datosWc, motivoIngresado });
            result.then((res) => {
              this.cargadorInterno = false;
             EventBus.$emit("procesarArrepentimiento", res);
            });
      }
      if (motivo == 8) {
        this.cargadorInterno = true;
        if (this.dias30) {
          datosWc.priority = "high";
          datosWc.wcTipo = 21643;
          datosWc.tags = ["-30 días", "PEDIDO ENTREGADO"];
        } else {
          datosWc.priority = "high";
          datosWc.wcTipo = 15493;
          datosWc.tags = ["Seguimiento"];
        }
        datosWc.content = `Hola, ${motivoIngresado.motivo.toLowerCase()}`;

        datosWc.status = "open";
        this.cargando = false;
        let result = this.vuexprocesarReclamo({ datosWc, motivoIngresado });
        result.then((res) => {
        if(res.ok || res.status)
        {
EventBus.$emit("procesarArrepentimiento", res);
        }
        else{
          this.$alert('No se generar el reclamo, refresque el navegador y intente nuevamente', 'Error', {
            type: 'error',
            confirmButtonText: 'Aceptar'
          });
        }
          
        });
      }

      if (motivo == 3) {
        // EventBus.$emit("verFormDemorado", motivoIngresado);
        this.cargadorInterno = true;
        datosWc.content = `Hola, me comunico para informarles que mi pedido esta demorado.`
        datosWc.priority= 'high'
        datosWc.status  = 'open'
        datosWc.tags    = ['Seguimiento']
        let result =  this.vuexprocesarReclamo({datosWc, motivoIngresado})
        result.then((res)=>{
          this.cargadorInterno = false;
          if(res.ok)
          {
            EventBus.$emit("procesarArrepentimiento", res);
          }
          else{
             
            this.$alert('No se generar el reclamo, refresque el navegador y intente nuevamente', 'Error', {
              type: 'error',
              confirmButtonText: 'Aceptar'
            });
          }
        })
      }

      let seleccionar_pedido = [5, 6, 9];
      if (seleccionar_pedido.includes(motivo)) {
        this.datos.motivo = this.datos.motivos.filter((m) => m.id == motivo)[0].motivo;
        this.detallePedido = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.btnMotivos {
  width: 90%;
  display: block;
  margin: 15px auto;
  box-shadow: 0.1px 0.1px 0.2px rgba(0, 0, 0, 0.038),
    0.3px 0.3px 0.5px rgba(0, 0, 0, 0.05), 0.6px 0.6px 1.2px rgba(0, 0, 0, 0.053),
    2px 2px 4px rgba(0, 0, 0, 0.05);

  white-space: normal;
  
  min-height: 55px;
  font-family: 'Montserrat', sans-serif;
  color: #FFF;
  background-color: #676767;
  border: none;
  text-align: left;
  font-size: 15px;
  transition: all 0.5s;
      padding-right: 23px;
      position: relative;
}
.btnMotivos i{
     text-align: right;
    float: right;
    font-size: 16px;
    position: absolute;
    top: 38%;
    right: 4%;
}
.btnMotivos:hover {
  border: 1px solid #BFBE51;
  background-color: #BFBE51;
  color: #000;
  // font-weight: bold;
}
.motivos {


  height: 100vh;
}
.titulo-motivo {
  margin: 0;
  padding-top: 15px;
  margin: 0;
  font-size: 20px;
  text-align: center;
  // padding-left: 20px;
  margin-bottom: 20px;
}
</style>
